import { lightGreen, amber, red } from "@material-ui/core/colors";
import { createMuiTheme } from "@material-ui/core/styles";

const muiTheme = createMuiTheme({
  palette: {
    primary: lightGreen,
    accent: amber,
    error: red
  }
});

export default muiTheme;



// WEBPACK FOOTER //
// ./src/styling/theme.js